// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"5ae84df8","631":"402f040f","760":"7603d5b6","774":"c1962476","787":"f76f0e8f","854":"df369fec"}[chunkId] + ".chunk.js";
};